import { render, staticRenderFns } from "./RenewSection.vue?vue&type=template&id=47b12d32&scoped=true&"
import script from "./RenewSection.vue?vue&type=script&lang=js&"
export * from "./RenewSection.vue?vue&type=script&lang=js&"
import style0 from "./RenewSection.vue?vue&type=style&index=0&id=47b12d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b12d32",
  null
  
)

export default component.exports